<template>
    <a-select
            showSearch
            v-model="model"
            :placeholder="placeholder"
            :defaultActiveFirstOption="false"
            :filterOption="false"
            @search="handleSearch"
            @change="handleChange"
            :notFoundContent="null"
            allowClear
    >
        <a-select-option v-for="option in options" :key="option.id"  :value="option.id" >{{option.name}} ({{option.phone}})</a-select-option>
    </a-select>
</template>
<script>
    import { getShopList} from '@/api/businessShop';
    export default {
    name: 'ShopPicker',
    data () {
      return {
//        model:undefined,
          options:[]
      }
    },
    props: {
      formData:{
        type: Object,
        required: true
      },
        field:{
            type: String|Number,
            required: true
        },
        placeholder:{
            type: String,
            default:'请选择门店'
        }
    },
    computed:{
        model:{
            get: function () {
                return this.formData[this.field];
            },
            set: function () {
            }
        }
    },
      watch: {
      },
      created(){
          
      },
    methods: {
        handleSearch(value){  
            let that = this;
            getShopList({ keywords: value }).then(res => {
                that.options = res.data.list
            })
       },
        handleChange(value){
            this.formData[this.field] = value;
       }
    },
  }
</script>
<style>

</style>